import BaseForm from '../BaseForm';

class EditForm extends BaseForm {
  state = {
    ...this.state,
    mode: this.props.match.params.id ? 'edit' : 'create',
  };

  static getDerivedStateFromProps(props, state) {
    const { successSave, edited: data, history } = props;

    if (state.mode === 'create' && successSave) {
      history.replace(history.location.pathname.replace('new', data.id));
      return { ...state, data, mode: 'edit' };
    }

    if (data && data.id) {
      return { ...state, data };
    }

    return null;
  }

  componentDidMount() {
    const { id } = this.props.match.params;

    if (id) {
      this.props.getById(id);
    }
  }

  componentDidUpdate() {
    if (this.props.successSave) {
      setTimeout(() => this.props.resetSuccessSave(), 3000);
    }
  }

  componentWillUnmount() {
    this.props.resetState();
  }
}

export default EditForm;



// WEBPACK FOOTER //
// ./src/components/EditForm/index.js